import type { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import checkBranchStatusSaga from './sagas/check-branch-status.js';
import createBranchSaga from './sagas/create-branch.js';
import deleteBranchSaga from './sagas/delete-branch.js';
import ensureScratchBranchSaga from './sagas/ensure-scratch-branch.js';
import fetchSchemaSaga from './sagas/fetch-schema.js';
import fetchServiceLayersSaga from './sagas/fetch-service-layers.js';
import getBranchListSaga from './sagas/get-branch-list.js';
import initBranchSaga from './sagas/init-branch.js';
import mergeBranchSaga from './sagas/merge-branch.js';
import openBranchMergeSaga from './sagas/open-branch-merge.js';
import postSchemaSaga from './sagas/post-schema.js';
import setCurrentBranchSaga from './sagas/set-current-branch.js';
import updateSchemaSaga from './sagas/update-schema.js';
import zustandGlueSaga from './sagas/zustand-glue.js';

export default function* root(): SagaIterator {
  yield all([
    fork(fetchServiceLayersSaga),
    fork(postSchemaSaga),
    fork(fetchSchemaSaga),
    fork(updateSchemaSaga),
    fork(initBranchSaga),
    fork(setCurrentBranchSaga),
    fork(openBranchMergeSaga),
    fork(mergeBranchSaga),
    fork(createBranchSaga),
    fork(deleteBranchSaga),
    fork(getBranchListSaga),
    fork(checkBranchStatusSaga),
    fork(ensureScratchBranchSaga),
    fork(zustandGlueSaga)
  ]);
}
